import { render, staticRenderFns } from "./UnauthorisedPage.vue?vue&type=template&id=b83d96b0&scoped=true"
import script from "./UnauthorisedPage.vue?vue&type=script&lang=js"
export * from "./UnauthorisedPage.vue?vue&type=script&lang=js"
import style0 from "./UnauthorisedPage.vue?vue&type=style&index=0&id=b83d96b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83d96b0",
  null
  
)

export default component.exports